module.exports = __webpack_public_path__ + "media/categories/1064-15f60cc5.svg";